import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
import makeStyles from '@mui/styles/makeStyles';
// @mui/icons-material
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Quote from "components/Typography/Quote.js";
// core components

import sectionTextStyle from "styles/jss/nextjs-material-kit-pro/pages/blogPostSections/sectionTextStyle.js";
import { TwitterTimelineEmbed, TwitterShareButton, TwitterFollowButton, TwitterHashtagButton, TwitterMentionButton, TwitterTweetEmbed, TwitterMomentShare, TwitterDMButton, TwitterVideoEmbed, TwitterOnAirButton } from 'react-twitter-embed';
import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';


const useStyles = makeStyles(sectionTextStyle);

export default function SectionText() {
  const classes = useStyles();
  const imgClasses = classNames(
    classes.imgRaised,
    classes.imgRounded,
    classes.imgFluid
  );
  return (
    <div className={classes.section}>
      <GridContainer justifyContent="center">
      
        
        <GridItem xs={12} sm={8} md={8}>
        <a className={classes.anchor} id="start"></a>
          <h3 className={classes.title}>Upcoming SEO Talk at Naturally Good Conference</h3>
          <p> 
          Hello internet! We will be speaking at the Naturally Good conference, held at the International Convention Centre (ICC), Darling Harbour in Sydney on Sunday 3rd of June, 2019 at 13:30pm-14:00pm.
          <br /><br /> 
          The talk is currently called: “How to Rank Number 1 on Google”.  Expect some theoretical discussion, a concrete example and an overview of the latest tools in SEO.
          <br /><br /> 
          For more info on the talk and the full schedule go here: <a href="https://naturallygood.com.au/whats-on/education-program/" target="_blank">https://naturallygood.com.au/whats-on/education-program/</a>
          <br /><br /> 
          If you are looking to drive and interested in <a href="https://adventuresinseo.com.au/icc-parking" target="_blank">icc parking</a> follow the link for some info on car parking at the ICC!
          <br /><br /> 
          Also if you are interested in a <a href="https://adventuresinseo.com.au/really-leftfield-keyword" target="_blank">Really Leftfield Keyword</a> click that link too!

          <br /><br /> 

          **** UPDATE 10/06/2019 ********* Here is a link to the slides from the talk! :-)

          <br /><br /> 

          </p>
 
          </GridItem>

          <GridItem xs={12} sm={10} md={10}>
                <Card
                  raised
                  //background
                  //style={{
                  //  backgroundImage: "url('/img/sections/services/google-analytics-training/1.jpg')",
                  //}}
                >
                  
                  <CardActionArea>
                    <CardMedia
                      component="iframe"
                      alt="Contemplative Reptile"
                      //className={classes.media}
                      height="500"
                      image="https://docs.google.com/presentation/d/e/2PACX-1vRxeoKWcgO8wS1y6-mehCXTFA4-yiH8OkiDxj0yBquIsDvSOwOlV0QsWBgoxpxLEA/embed?start=false&loop=false&delayms=3000"
                      //title="Contemplative Reptile"
                    />

                  </CardActionArea>
                </Card>  
                <p><br /><br /></p>       
              </GridItem>

        


      </GridContainer>
    </div>

  );
}
